import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";
import { EmployeeProfile } from "@/modules/administration/features/EmployeeDirectoryManagement/api/Profile/fetchEmployeeProfiles/types";

interface DeleteEmployeeProfileConfirmationProps {
  profile: EmployeeProfile | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteEmployeeProfileConfirmation: React.FC<
  DeleteEmployeeProfileConfirmationProps
> = ({ profile, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={profile !== null}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Delete Employee Profile
      </h3>
      <p className="mt-3 text-sm text-gray-600">
        Are you sure you want to delete this employee profile? This action
        cannot be undone.
      </p>

      <div className="mt-6 flex justify-end space-x-3">
        <Button onClick={onClose} variant="outline">
          Cancel
        </Button>
        <Button onClick={onConfirm}>Delete Employee Profile</Button>
      </div>
    </Modal>
  );
};

export default DeleteEmployeeProfileConfirmation;
